module.exports = __webpack_public_path__ + "static/media/builder_add_field_dnd.a2eabc0b.gif";